export default __webpack_public_path__ + "static/media/crusharmor3.f5fb1d8f.png";